import * as React from "react";
import { bottomNavItems } from "../nav.tsx";
import { BottomNavItem } from "./BottomNavItem.tsx";

export const BottomNav: React.FC = () => {
  return (
    <nav className="bottom-nav only-phone" aria-label="Main">
      {bottomNavItems.map((item) => (
        <BottomNavItem key={item.label} item={item} />
      ))}
    </nav>
  );
};
